import { app } from '../../app';
import { Controller } from './sp-directory-label.controller';

app.component('spDirectoryLabel', {
    bindings: {directoryDto: '<'},
    controller: Controller,
    templateUrl: require('./sp-directory-label.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-directory-label/sp-directory-label.component.js